// 导入请求数据的 request 模块
import request from '@/utils/request'

// 根据省份查询职业招聘信息
export const selectRecruit = (province, currentPage, pageSize) => {
  return request.get('/recruit/select', {
    params: {
      province: province,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}

// 根据公司名称查询职业招聘信息
export const SelectRecruitCompany = (company, currentPage, pageSize) => {
  return request.get('/recruit/select/company', {
    params: {
      company: company,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}

// 根据招聘名称查询职业招聘信息
export const SelectRecruitName = (name, currentPage, pageSize) => {
  return request.get('/recruit/select/name', {
    params: {
      name: name,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}

// 根据文件id下载文件
export const filesDownloadByIdRecruit = (id) => {
  return request.post('/recruit/select/id', id, {
    params: {
      id
    },
    responseType: 'blob'
  })
}
